import { POST } from '../_http';
import type { operations } from '@/types/schemas/calcs.main';
type controller = operations['LoanAmountController_calculate'];

export type LoanAmountBody = controller['requestBody']['content']['application/json'];
export type LoanAmountResponse = controller['responses']['200']['content']['application/json'];

export const loanAmount = POST('/formulas/loan-amount')<LoanAmountBody, LoanAmountResponse>;
